export const walletDetectorABI = [
	"function isArgentWallet(address _wallet) external view returns (bool)",
];

export const walletGuardianABI = [
	"function guardianCount(address _wallet) external view returns (uint256)",
];
